var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.021,
    height: 25.463,
    viewBox: "0 0 30.021 25.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(1.055 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M1.686,14.322A7.083,7.083,0,0,0,7.513,24.45c.146.008.293.012.441.012s.3,0,.441-.012a7.083,7.083,0,0,0,5.827-10.129L7.955,1Z",
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#2182eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(19.731 0.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M26.671,5.66l3.91-3.91,3.91,3.91",
    transform: "translate(-26.671 -1.75)",
    fill: "none",
    stroke: "#eb6f21",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M26.671,13.66l3.91-3.91,3.91,3.91",
    transform: "translate(-26.671 -2.535)",
    fill: "none",
    stroke: "#eb6f21",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumid);
export default __webpack_public_path__ + "static/media/humid.d4adb91296f8dbf34cd5667d1f0eef42.svg";
export { ForwardRef as ReactComponent };